export default __webpack_public_path__ + "static/media/waypoint_single.eeb243a7.svg";